import { Box, Stack, Text } from '@chakra-ui/react';

const CopyrightInfoBox = () => {
  return (
    <Box
      sx={{
        width: '100%',
        minWidth: { base: '100%', md: '730px' },
        paddingTop: { base: '10px', md: '73px' },
        paddingBottom: { base: '10px' },
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="space-between"
        gap={'18px'}
        maxHeight={{ base: 'auto', md: '141px' }}
      >
        <Stack
          width="100%"
          flexDirection={{ base: 'column', md: 'row' }}
          justifyContent="space-between"
          gap={'18px'}
          maxHeight={{ base: 'auto', md: '53px' }}
        >
          <Box>
            <Text
              fontFamily={'League Spartan'}
              fontSize="14px"
              lineHeight="18px"
              textAlign={{ base: 'center', md: 'left' }}
              maxWidth={{ base: '100%', md: '323px' }}
              mb={{ base: 1, md: 0 }}
              paddingX={{ base: '8px', md: '0' }}
            >
              © Copyrights 2017 - 2025 Software Hub sp. z o.o. <br />
              02-495 Warszawa, ul. Ryżowa 33a/7
              <br /> +48 22 398 74 85 | biuro@softwarehub.pl
            </Text>
          </Box>
          <Box>
            <Text
              fontFamily={'League Spartan'}
              fontSize="14px"
              lineHeight="18px"
              textAlign={{ base: 'center', md: 'right' }}
              maxWidth={{ base: '100%', md: '323px' }}
              mb={{ base: 1, md: 0 }}
              paddingX={{ base: '8px', md: '0' }}
            >
              Inspektor ochrony danych
              <br />
              Małgorzata Ganczar
              <br />
              iod@softwarehub.pl
            </Text>
          </Box>
        </Stack>
        <Box maxHeight={{ base: 'auto', md: '53px' }} paddingY={{ base: '4px', md: '0' }}>
          <Text fontSize={{ base: '9px', md: '12px' }} textAlign="center">
            KRS: 0000629823, NIP: 7831745232, REGON: 365083606. Kapitał zakładowy 100 000 PLN
            (wpłacony w całości).
          </Text>
        </Box>
        <Box maxHeight="auto" paddingY={{ base: '2px', md: '2px' }}>
          <Text fontSize={{ base: '9px', md: '12px' }} lineHeight="12px" textAlign="center">
            © 4Parents 2025 | sukces zaczyna się w Hubie
          </Text>
        </Box>
      </Stack>
    </Box>
  );
};

export default CopyrightInfoBox;
